<div class="container">

    <div class="log-header">
        <img src="./assets/CAISOlogo.jpg">
    </div>

    <h1>{{pageHeading}}</h1>
    <p *ngIf="(!requestFailed || !requestProcessed) &&  currentStep==step2">Enter your email and click Submit to get mail with unsubscribe link.</p>

    <div class="container px-2 pt-2">

        <div id="divPageProgress" class="row loaderDiv" *ngIf="!dataLoaded">
            <div class="col-12 text-center">
                <div class="text-primary progressAnimation">
                    <div class="loader"></div>
                </div>
            </div>
        </div>



        <div *ngIf="requestProcessed || requestFailed" class="operationMessage"
            [ngClass]="{'failedRequestMessage' : requestFailed}">
            {{messageToDisplay}}
        </div>


        <form #subscriptionEamilForm="ngForm" (ngSubmit)="GetUnsubscribeLinkMail(subscriptionEamilForm)"
        *ngIf="(!requestProcessed && !requestFailed) && dataLoaded && currentStep==step1">
       
        <div class="form-group mt-2">
            <label for="emailAddress">Email address<span class="required">*</span></label>
            <div *ngIf="emailAddress.invalid && (emailAddress.dirty || emailAddress.touched)" class="errorMessage">
                <div *ngIf="emailAddress.errors.required">
                    Email address is required.
                </div>
                <div *ngIf="emailAddress.errors.pattern">
                    Email address is not in valid format.
                </div>
            </div>

            <input #emailAddress="ngModel" required type="email" name="emailAddress" autocomplete="off"
                [ngClass]="{'is-invalid' : emailAddress.invalid && (emailAddress.dirty || emailAddress.touched)}"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                class="form-control  ng-untouched ng-pristine ng-valid clear" [(ngModel)]="userEmail">


        </div>

        <button class="btn btn-primary mt-4" type="submit">Get mail with unsubscribe link</button>
    
       </form>



       <div class="row"  *ngIf="(!requestProcessed && !requestFailed) && userMessage && currentStep==step2" >
            <div class="col-12 text-center p4">
                {{userMessage}}
            </div>
       </div> 
      
    </div>
</div>